export interface AuthorizationRequest {
    codeVerifier: string;
    state: string;
    route: string;
}

const CODE_VERIFIER_KEY = "xola.oauth.codeVerifier";
const STATE_KEY = "xola.oauth.state";
const ROUTE_KEY = "xola.oauth.route";
const RETRIED_KEY = "xola.oauth.retried";

export const saveAuthorizationRequest = ({ codeVerifier, state, route }: AuthorizationRequest) => {
    sessionStorage.setItem(CODE_VERIFIER_KEY, codeVerifier);
    sessionStorage.setItem(STATE_KEY, state);
    sessionStorage.setItem(ROUTE_KEY, route);
};

/** Reads the pending request and always clears it, so a failed exchange cannot be replayed. */
export const consumeAuthorizationRequest = (): AuthorizationRequest | null => {
    const codeVerifier = sessionStorage.getItem(CODE_VERIFIER_KEY);
    const state = sessionStorage.getItem(STATE_KEY);
    const route = sessionStorage.getItem(ROUTE_KEY);

    sessionStorage.removeItem(CODE_VERIFIER_KEY);
    sessionStorage.removeItem(STATE_KEY);
    sessionStorage.removeItem(ROUTE_KEY);

    if (!codeVerifier || !state) {
        return null;
    }

    return { codeVerifier, state, route: route ?? "/" };
};

export const hasRetriedSignIn = () => sessionStorage.getItem(RETRIED_KEY) === "1";

export const markSignInRetried = () => sessionStorage.setItem(RETRIED_KEY, "1");

export const clearSignInRetry = () => sessionStorage.removeItem(RETRIED_KEY);
